import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getLocaleFromPathname,
  localizePath,
  stripLocalePrefix,
  isPublicLocalizedPath,
} from '../i18n/routing';

export function useLocale() {
  const { pathname } = useLocation();
  const locale = getLocaleFromPathname(pathname);

  const localizedPath = useCallback(
    (path) => localizePath(path, locale),
    [locale]
  );

  return {
    locale,
    localizedPath,
    barePath: stripLocalePrefix(pathname),
    isPublicLocalized: isPublicLocalizedPath(pathname),
    isEnglish: locale === 'en',
  };
}
